import React, { memo } from 'react';
import PropTypes from 'prop-types';
import DateToPayEditCellOnboarding from '../dataGridCells/DateToPayEditCellOnboarding';
import useRowDateToPayState from '../../hooks/useRowDateToPayState';

/**
 * DateToPaySelectionStateManagerCell
 *
 * This component handles the state management for date selection
 * so that general buttons (30/60/90 days) are automatically
 * deselected when a specific date is selected in the row.
 *
 * Functionality:
 * - When the date is changed in DateToPayEditCellOnboarding, it marks
 *   the row as modified (setSingleRowModified(true))
 * - This modified state is used in SelectDaysButtonsSelectionStateManagerCell
 *   to pass unselectButtons=true, which deselects the general buttons
 * - Allows only the specifically selected date to be shown, not the
 *   general day buttons
 */

const DateToPaySelectionStateManagerCell = memo(({ params }) => {
  const { setSingleRowModified } = useRowDateToPayState(params.row.receiver.id);
  const handleDateChange = () => {
    setSingleRowModified(true);
  };

  return (
    <DateToPayEditCellOnboarding
      params={params}
      onDateChange={handleDateChange}
    />
  );
});

DateToPaySelectionStateManagerCell.propTypes = {
  params: PropTypes.shape({
    row: PropTypes.shape({
      id: PropTypes.string.isRequired,
      receiver: PropTypes.shape({
        id: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
};

export default DateToPaySelectionStateManagerCell;
